import React from 'react'
import { Button } from 'react-bootstrap'
import { AiOutlineRight } from 'react-icons/ai'

const PrimaryButton = ({ children, url, variant, className, blank }) => {
  const target = () => {
    let t = 'base'

    if (blank) {
      t = '_blank'
    }

    return t
  }

  //future state it would be nice to have logic to determine primary and secondary cta text
  // const defaultText = variant === "primary" ? "Shop Now" : "Learn More";
  // const text =  text > 0 ? text : defaultText;

  return (
    <Button
      href={url}
      variant={variant}
      className={className}
      target={target()}
    >
      {children}
      <span className='icon d-none d-lg-block'>
        <AiOutlineRight />
      </span>
    </Button>
  )
}

export default PrimaryButton
